import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

const Success = ({ user, event, sessions, message }) => {
    if (!user || !event) {
        return <p className="messaging -error">There was an error processing your registration.</p>;
    }

    return (
        <>
            <header className="registration__header">
                <div className="container">
                    <h2 className="registration__eventTitle">
                        Thank you, <span>{user.firstName}</span>!
                    </h2>
                    <p className="messaging -success -light">{message}</p>
                </div>
            </header>
            <div className="registration__form registration__confirmation container">
                <div className="grid -thirdReverse">
                    <div className="grid__cell">
                        <h2 className="heading">{event.title}</h2>
                    </div>
                    <div className="grid__cell">
                        <a href={event.calendarUrl} className="button">
                            Add Event to Calendar
                        </a>
                    </div>
                </div>
                <ul className="registration__eventDetails grid -col3">
                    <li className="grid__cell">
                        <strong className="caps">When:</strong>
                        <p>
                            <span className="registration__details">
                                {event?.startDate &&
                                    dayjs
                                        .tz(
                                            event.startDate.date,
                                            event.virtual ? user.timezone : event.startDate.timezone
                                        )
                                        .format('MMMM D, YYYY h:mmA z')}
                            </span>
                        </p>
                    </li>
                    <li className="grid__cell">
                        <strong className="caps">Where:</strong>
                        <p>
                            <span className="registration__details">
                                {!event?.venue && !event?.city && <span>{event?.location}</span>}
                                {(!!event?.venue || !!event?.city) && (
                                    <>
                                        <span style={{ display: 'inline-block' }}>{event?.venue}</span>
                                        <span>{event?.city}</span>
                                    </>
                                )}
                            </span>
                        </p>
                    </li>
                    {!!event.host && (
                        <li className="grid__cell">
                            <strong className="caps">Host/Primary Sponsor: </strong>
                            <p>{event.host}</p>
                        </li>
                    )}
                </ul>
                <span className="caps">Basic Information:</span>
                <ul className="confirmation__eventDetails grid -col3">
                    <li className="grid__cell">
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="meta -dark">First Name</label> <span>{user.firstName}</span>
                    </li>
                    <li className="grid__cell">
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="meta -dark">Last Name</label> <span>{user.lastName}</span>
                    </li>
                    <li className="grid__cell">
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="meta -dark">Nickname</label> <span>{user.nickname}</span>
                    </li>
                    <li className="grid__cell">
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="meta -dark">Firm</label> <span>{user.acct}</span>
                    </li>
                    <li className="grid__cell">
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="meta -dark">Title</label> <span>{user.jobTitle}</span>
                    </li>
                    <li className="grid__cell" />
                    <li className="grid__cell">
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="meta -dark">Email</label> <span>{user.email}</span>
                    </li>
                    <li className="grid__cell">
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="meta -dark">Phone</label> <span>{user.phone}</span>
                    </li>
                </ul>
                {Object.keys(sessions).length > 0 && (
                    <div>
                        <span className="caps">Sessions:</span>
                        <table className="agenda -confirmation">
                            <tbody>
                                <tr className="agenda__trackNames">
                                    <th className="sr-only">Session Date</th>
                                    <th className="sr-only">Session Time</th>
                                    <th className="sr-only">Session Name</th>
                                    <th className="sr-only">Session Category</th>
                                    {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                                    <th className="sr-only" />
                                </tr>

                                {Object.values(sessions)
                                    .filter((session) => session.isSelected)
                                    .map((session) => (
                                        <tr key={session.sessionId}>
                                            <td>{dayjs(session.sessionDate).format('MMM D')}</td>
                                            <td>
                                                {dayjs(session.sessionStartTime, 'HH:mm:ss').format('h:mmA')} -{' '}
                                                {dayjs(session.sessionEndTime, 'HH:mm').format('h:mmA z')}
                                            </td>
                                            <td>
                                                <div>{session.sessionTitle}</div>
                                                <div>{session.additionalInformation}</div>
                                            </td>
                                            <td>{session.track}</td>
                                            <td>
                                                <a className="registration__addToCalendar" href={session.calendarUrl}>
                                                    Add to Calendar
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                )}
                <p>
                    <a href="/events" className="button">
                        Back to Events
                    </a>
                </p>
            </div>
        </>
    );
};

Success.propTypes = {
    user: PropTypes.object,
    event: PropTypes.object,
    sessions: PropTypes.object,
    message: PropTypes.string.isRequired,
};

export default Success;
